module.exports = __webpack_public_path__ + "static/media/chorthippus_mollis.d74aef3e.png";